<template>
  <div class="flex mb-12 bulk-quiz-form">
    <div class="w-3/5 content-left-panel">
      <div class="flex flex-wrap mt-10">
        <upload-file
          automatic
          class="w-full pl-0"
          text="Bulk Quiz creation and update by CSV"
          @on-success="successUpload"
          @on-error="errorUpload"
          :uploadMethod="uploadQuizCSVWrapper"
        />
        <small class="ml-3">Choose a file, this will be uploaded automatically</small>
      </div>
      <div class="bulk-results" v-if="responseToShow">
        <h4 class="mt-10 mb-5">Results</h4>
        <ul class="flex w-full flex-wrap" v-if="responseToShow.results">
          <li class="mt-5 w-1/3">
            Quizzes created: <strong>{{responseToShow.results.quizzes.created.length}}</strong> <br/>
            Quizzes updated: <strong>{{responseToShow.results.quizzes.updated.length}}</strong>
          </li>
          <li class="mt-5 w-1/3">
            Questions created: <strong>{{responseToShow.results.questions.created.length}}</strong> <br/>
            Questions updated: <strong>{{responseToShow.results.questions.updated.length}}</strong>
          </li>
          <li class="mt-5 w-1/3">
            Answers created: <strong>{{responseToShow.results.answers.created.length}}</strong> <br/>
            Answers updated: <strong>{{responseToShow.results.answers.updated.length}}</strong>
          </li>
        </ul>
        <vs-divider/>
        <h4 class="mt-10 mb-5">List of quizzes</h4>
        <ul class="w-full" v-if="responseToShow.mapping">
          <li class="mb-5" v-for="quiz in responseToShow.mapping" :key="quiz.quiz_uuid">
            <router-link :to="{name: 'edit-quiz', params: {id: quiz.quiz_uuid}}">{{quiz.quiz_uuid}}</router-link> - {{quiz.video_reference}}
          </li>
        </ul>


      </div>
    </div>
    <div class="w-2/5 pl-10 content-right-panel">

    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import UploadFile from "../components/UploadFile";

export default {
  components: {
    UploadFile
  },
  data: () => {
    return {
      responseToShow: null
    }
  },
  methods: {
    ...mapActions('quizzes', ['uploadQuizCSV']),
    errorUpload(error) {
      this.showError(error)
    },
    successUpload() {
    },
    async uploadQuizCSVWrapper(formData) {
      try {
        this.$vs.loading();
        const response = await this.uploadQuizCSV(formData);
        this.responseToShow = response

        this.$vs.notify({
          color: "success",
          title: "Upload Success",
          text: "The file was uploaded successfully"
        });
      } catch (error) {
        this.showError(error)
      }
      this.$vs.loading.close();
    }
  }
}
</script>
<style lang="scss">
.bulk-quiz-form {
  .content-left-panel {
    .con-img-upload {
      .img-upload {
        height: 100px;
        width: 100px;
      }
      .text-archive {
        font-size: 0.8em;
      }
    }
    .con-input-upload {
      margin: 0;
      width: 100%;
      height: 100px;
    }
  }
}
</style>